import { render } from "./BlocksHome.vue?vue&type=template&id=ec0125fc&scoped=true"
import script from "./BlocksHome.vue?vue&type=script&lang=js"
export * from "./BlocksHome.vue?vue&type=script&lang=js"

import "./BlocksHome.vue?vue&type=style&index=0&id=ec0125fc&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec0125fc"]])

export default __exports__